/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import {
  Input,
  Button,
  Radio,
  DatePicker,
  notification
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';

class TeamPlantSLOC extends Component {
/** JSON.parse(localStorage.getItem("companyData") */
  constructor(props) {
    super(props);
    this.state = {
      factUpdate: false,
      LangTranslate: [[]],
      title: "Team Plant SLOC",
      teamDataList: [],//JSON.parse(localStorage.getItem("companyData")),
      teamGroupIDAdd: 0,
      teamRefSLOCIDAdd: 0,
      teamIDAdd: 0,
      plantIDAdd: 0,
      SLOCIDAdd: 0,
      AddTeamPlantSlocDisplay: "none",
      ConfirmDisplay: "none",
      dateFormat: "DD/MM/YYYY",
      EffectiveDateAdd: moment().toDate(),
      EffectiveDateAddFilter: moment().toDate(),
      ExpiryDateAdd: moment().toDate(),
      statusAdd: 1,
      active: ["Inactive","Active"],
      where: "",
      
      filterDataList: [],
      fillEffectiveDateDisplay: "none",
      resultAddNewFail: false,
      resultAddNewText: "",
      actionTeamPlantSLOC: "Add",
      actionTeamPlantSLOCButton: "Add",
      disableChangeValue: false,

      companyDataList: JSON.parse(localStorage.getItem("companyData")),
      companyID: Number(Cookies.get("companyid")),
      operatorID: Number(Cookies.get("operator_id")),
      projectID: Number(Cookies.get("project_id")),
      operatorIDAdd: Number(Cookies.get("operator_id")),
      projectIDAdd: Number(Cookies.get("project_id")),
      operator: [],
      projectData: [],
      filterProjectdata: [],
      filterOperatordata: [],

      operatorAdd: [],
      projectDataAdd: [],
      plantList: [],
      SLOCList: [],

      filterProjectdataAdd: [],
      TeamGroupDataList: [],
      TeamSubDataList: []
    };
  }

  async componentDidMount() {
    Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          LangTranslate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factUpdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });

      if (
        localStorage.getItem("projectData") === null ||
        localStorage.getItem("projectData") === undefined
      ) {
        this.logoutClicked();
      } else {
        const filterProjectdata = JSON.parse(
          localStorage.getItem("projectData")
        ).filter((data) => {
          //return data.operator_id == Cookies.get("operator_id");
          return data.operator_id == this.state.operatorID;
        });
        this.setState({
          operator: JSON.parse(localStorage.getItem("operator")),
          projectData: filterProjectdata,
        });

        const filterProjectdataAdd = JSON.parse(
          localStorage.getItem("projectData")
        ).filter((data) => {
          //return data.operator_id == Cookies.get("operator_id");
          return data.operator_id == this.state.operatorIDAdd;
        });
        this.setState({
          operatorAdd: JSON.parse(localStorage.getItem("operator")),
          projectDataAdd: filterProjectdataAdd,
        });
      }
      this.loadTeamGroup();
      this.loadTeamPlantSLOC();
      this.loadPlant();
      
  }

  onSearch = () => {
    this.loadTeamPlantSLOC();
  }

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  setOperatorAdd = (event) => {
    this.setState({
      teamIDAdd: 0,
      operatorIDAdd: event.target.value
    });

    const filterProjectdataAdd = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });

    this.setState({
      projectIDAdd: "",
      projectDataAdd: filterProjectdataAdd,
    });
  };

  loadPlant = () => {
    Api.post("master_data/get_plant", {
      company_id: this.state.companyID,
      where: "",
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        this.setState({plantList: data.result, plantIDAdd: 0, SLOCIDAdd: 0, SLOCList: []});
      }
    })
    .catch((e) => {
      console.log("error load plant", e);
    })
  }

  loadSLOC = () => {
    Api.post("master_data/get_sloc_by_plant", {
      company_id: this.state.companyID,
      plant_id: this.state.plantIDAdd,
      where: "",
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        this.setState({SLOCList: data.result, SLOCIDAdd: 0});
      }
    })
    .catch((e) => {
      console.log("error load sloc", e);
    })
  }


  setProjectDataAdd = (event) => {
    this.setState({
      projectIDAdd: event.target.value
    })
    //this.loadJobTypeDataAdd();
  };

  setPlantAdd = (event) => {
    this.setState({plantIDAdd: event.target.value});
    Api.post("master_data/get_sloc_by_plant", {
      company_id: this.state.companyID,
      plant_id: event.target.value,
      where: "",
    })
    .then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        this.setState({SLOCList: data.result, SLOCIDAdd: 0});
      }
    })
    .catch((e) => {
      console.log("error load sloc", e);
    })
  }

  loadTeamGroup = () => {
    this.setState({TeamGroupDataList:[]});
    Api.post("master_data/GetTeamGroup", {
      company_id : this.state.companyID,
      operator_id : this.state.operatorID,
      project_id : this.state.projectID,
      team_group_duty_code : "O"
    })
      .then((res) => {
        const { result, list } = res.data;
        if (result.value === "P") {
          this.setState({ TeamGroupDataList: list, teamGroupIDAdd: 0, teamIDAdd: 0})
          this.loadTeamSub();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadTeamSub = () => {
    console.log('teamGroupIDAdd:'+ this.state.teamGroupIDAdd);
    this.setState({TeamSubDataList:[]});
    Api.post("master_data/GetTeamSub", {
      company_id : this.state.companyID,
      operator_id : this.state.operatorID,
      project_id : this.state.projectID,
      team_group_id : this.state.teamGroupIDAdd
    })
      .then((res) => {
        const { result, list } = res.data;
        console.log('team group:'+ this.state.teamGroupIDAdd +' team = ',list)

        if (result.value === "P") {
          this.setState({ TeamSubDataList: list})
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadTeamPlantSLOC = () => {
    this.state.filterDataList = [];
    Api.post("master_data/get_list_team_plant_sloc", {
      company_id : this.state.companyID,
      operator_id : this.state.operatorID,
      project_id : this.state.projectID,
      where : this.state.where
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          const tmp = [];
          data.result.map((item, index) => (
            tmp.push({
            "teamName": item.team_name,
            "plantName": item.plant_name,
            "SLOCName": item.sloc_name,
            "status": <div className={(item.is_active)?"problem-type-Active":"problem-type-Inactive"}>{(item.is_active)? "Active":"Inactive"}</div>,
            "effectiveDate": this.displayDate(item.effective_date),
            "expiredDate": this.displayDate(item.expire_date),
            "Option":<button onClick={()=> this.clickEdit(item.team_ref_sloc_id,item.team_group_id,item.team_id,item.plant_id,item.sloc_id,item.is_active,item.effective_date,item.expire_date)} id={"btnEdit"+index} className="text-primary">edit</button>
            })
          ));
          this.setState({ filterDataList: tmp, operatorIDAdd:this.state.operatorID,projectIDAdd:this.state.projectID});
          
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /** item.team_ref_sloc_id,item.team_id,item.plant_id,item.sloc_id,item.is_active,item.effective_date,item.expire_date */
  clickEdit = (team_ref_sloc_id,team_group_id, team_id, plant_id, sloc_id, is_active, effective_date, expire_date) => {
    console.log('team_id:'+team_id+' plant_id:'+plant_id+' sloc id:'+sloc_id+' is_active:'+is_active);
    this.setState({
      operatorIDAdd: this.state.operatorID,
      projectIDAdd: this.state.projectID,
      teamRefSLOCIDAdd: team_ref_sloc_id,
      teamGroupIDAdd: team_group_id,
      teamIDAdd: team_id,
      plantIDAdd: plant_id,
      EffectiveDateAdd: (effective_date != null)? this.displayDate(effective_date) : "",
      EffectiveDateAddFilter: (effective_date != null)? effective_date : "",
      ExpiryDateAdd: (expire_date != null)? this.displayDate(expire_date) : "",
      actionTeamPlantSLOC: "Edit",
      actionTeamPlantSLOCButton: "Save"
    })
    this.state.statusAdd = is_active;
    console.log('status:'+this.state.statusAdd);
    this.onAddTeamPlantSLOC();
    Api.post("master_data/GetTeamSub", {
      company_id : this.state.companyID,
      operator_id : this.state.operatorID,
      project_id : this.state.projectID,
      team_group_id : team_group_id
    })
      .then((res) => {
        const { result, list } = res.data;
        if (result.value === "P") {
          this.setState({ TeamSubDataList: list})
        }
      })
      .catch((e) => {
        console.log(e);
      });
      Api.post("master_data/get_sloc_by_plant", {
        company_id: this.state.companyID,
        plant_id: plant_id,
        where: "",
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({SLOCList: data.result, SLOCIDAdd: sloc_id});
        }
      })
      .catch((e) => {
        console.log("error load sloc", e);
      })

  };

  setOperator = (event) => {
    this.setState({
      operatorID: event.target.value
    });

    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == event.target.value;
    });

    this.setState({
      projectID: "",    
      projectData: filterProjectdata,
    });

  }

  setProjectData = (event) => {
    this.setState({
      projectID: event.target.value
    })
  }

  setStatus = (event) => {
    this.setState({
      statusAdd: event.target.value
    })
  }

  setSearchText = (event) => {
    this.state.where = event.target.value
  }

  onChangeEffectiveDate = (date, dateString) =>{
    this.setState({
      EffectiveDateAdd: date,
      EffectiveDateAddFilter: date
    })
    console.log('effect  date = '+this.state.EffectiveDateAdd)
  }

  onChangeExpiryDate = (date, dateString) => {
    this.setState({
      ExpiryDateAdd: date
    })
  }

  onAddTeamPlantSLOC = () => {
    window.scrollTo(0, 0);
    if(this.state.AddTeamPlantSlocDisplay == "none"){
      this.setState({
        AddTeamPlantSlocDisplay: "block"
      })
    }else{
      this.setState({
        AddTeamPlantSlocDisplay: "none"
      })
    }
  }

onCallConfirmWindow = () => {
  if(this.state.ConfirmDisplay == "none"){
    this.setState({ConfirmDisplay: "block"});
  }else{
    this.setState({ConfirmDisplay: "none", resultAddNewFail: false})
  }
}

onResetFormAddNew = () => {
  this.onCallConfirmWindow();
  this.onCloseAddNewWindow();
}

onCloseAddNewWindow = () => {
  this.setState({
    operatorIDAdd: 0,
    projectIDAdd: 0,
    teamGroupIDAdd: 0,
    TeamGroupDataList: [],
    teamRefSLOCIDAdd: 0,
    teamIDAdd: 0,
    TeamSubDataList: [],
    plantIDAdd: 0,
    SLOCIDAdd: 0,
    SLOCList: [],
    statusAdd: 1,
    EffectiveDateAdd: moment().toDate(),
    EffectiveDateAddFilter: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),
    actionTeamPlantSLOC: "Add",
    actionTeamPlantSLOCButton: "Add",
    disableChangeValue: false
  })
  this.onAddTeamPlantSLOC();
  this.loadTeamGroup();
}

displayDate  = (data) => {
  if(data != null){
    const day = data.substring(0,10).split("-");
    return day[2] + "/" + day[1] + "/" + day[0];
  }
  return "-";
}

onCallConfirmWindowAndCallAddNewAgain = () => {
  this.onCallConfirmWindow();
  this.onAddTeamPlantSLOC();
}

ClickAction = (e) => {
  window.scrollTo(0, 0);
  e.preventDefault();

  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    // statement save data 
    (this.state.actionTeamPlantSLOC == "Add") ? 

      Api.post("master_data/insert_team_plant_sloc", {
        team_id : this.state.teamIDAdd,
        plant_id : this.state.plantIDAdd,
        sloc_id : this.state.SLOCIDAdd,
        is_active: this.state.statusAdd,
        effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
        expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null
    })
      .then((res) => {
        console.log('Action: Add');
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({resultAddNewFail: false})
          
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddProblemTypeDisplay : "none",resultAddNewFail: true})
        }
        if(result.showText == "Success"){
          this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
        }else{
          this.setState({resultAddNewText:result.showText});
        }
        /** confirm */
        this.onCallConfirmWindow();
        this.loadTeamPlantSLOC();
      })
      .catch((e) => {
        console.log("error add new problem type", e);
      })
    : this.editData(e)
    
    /** statement save data */
  }
  
  e.stopPropagation();
}

editData = (e) => {
  console.log('Action: Edit');
  window.scrollTo(0, 0);
  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    /** statement save data */
    Api.post("master_data/update_team_plant_sloc", {
      team_ref_sloc_id : this.state.teamRefSLOCIDAdd,
      team_id : this.state.teamIDAdd,
      plant_id : this.state.plantIDAdd,
      sloc_id : this.state.SLOCIDAdd,
      is_active: this.state.statusAdd,
      effective_date: moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      expire_date: (this.state.ExpiryDateAdd) != ''? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):null,
      TokenUser : Cookies.get(`OperationToken`)
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({resultAddNewFail: false})
          this.onCloseAddNewWindow();
        }else{
          this.setState({AddPlantDisplay : "none",resultAddNewFail: true})
        }
        if(result.showText == "Success"){
          this.setState({resultAddNewText:"แก้ไขข้อมูลเสร็จสิ้น"});
        }else{
          this.setState({resultAddNewText:result.showText});
        }
        // confirm 
        this.onCallConfirmWindow();
        this.loadTeamPlantSLOC();
      })
      .catch((e) => {
        console.log("error editing Team Plant SLOC", e);
      })
      
  }
}

/*8888888888888888888888888888*/
setTeamAdd = (event) => {
  this.setState({teamIDAdd: event.target.value})
}

setTeamGroupAdd = (event) => {
  //console.log('tg='+event.target.value);
  this.state.teamGroupIDAdd = event.target.value;
  this.loadTeamSub();
}

setPlantNameAdd = (event) => {
  this.setState({plantNameAdd:event.target.value})
}

setSLOCNameAdd = (event) => {
  this.setState({SLOCIDAdd: event.target.value})
}

setDescriptionAdd = (event) => {
  this.setState({descriptionAdd:event.target.value})
}

render() {
  const locale = Cookies.get("locale");
  const columns =  [
    
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["teamName"] : `Team Name`,
      selector: 'teamName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["plantName"] : 'Plant Name',
      selector: 'plantName',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["SLOCName"] : 'SLOC Name',
      selector: 'SLOCName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : 'Status',
      selector: 'status',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
      selector: 'effectiveDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
      selector: 'expiredDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Action"] :'Action',
      selector: 'Option',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: 'cursor:pointer'
    },
  ];

        return (
            <div>
                <span className="font-mont-r fs-12">Basic Data</span>
                <h3 className="font-mont-sb fs-18 c-blue">{this.state.title}</h3>
                <div className="w-100 box-search m-0">
                  <div className="row">
                    <div>
                        <div className="title-search">Operator</div>
                        <div>
                          <select
                          placeholder="Please select Operator"
                          className="dropdrowtype input-text-add-problem-type form-select"
                          onChange={this.setOperator}
                          value={this.state.operatorID}
                        >
                          <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                          {this.state.operator.map((item, index) => (
                            <option
                              value={item.operator_id}
                              key={`layoutoption_${index}`}
                            >
                              {item.operator_name}
                            </option>
                          ))}
                          </select>
                        </div>
                      </div>
                      <div className="ml-0 pl-3">
                        <div className="title-search">Project</div>
                        <div className="row">
                            <div>
                            <select
                                placeholder="Please select Project"
                                className="dropdrowtype input-text-add-problem-type form-select"
                                onChange={this.setProjectData}
                                value={this.state.projectID}
                              >
                                <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                              {this.state.projectData.map((item, index) => (
                                <option value={item.project_id} key={`layout_b_${index}`}>
                                  {item.project_name}
                                </option>
                              ))}
                            </select>
                            </div>
                            <div style={{verticalAlign:"text-top"}}>
                              <div className="m-0 pl-2">
                                <Input
                                  onChange={(e)=>this.setSearchText(e)}
                                  placeholder="Search Team Name"
                                  style={{ width: "210px"}}
                                />
                                <img type="button" src={butSearch} onClick={this.onSearch} className="but-search"/>
                              </div>
                            </div>
                        </div>
                      </div>

                      <div className="box-but-add-SLOC">
                        <div className="pt-1">
                        <button className="but-add-problem-type" onClick={this.onAddTeamPlantSLOC}>Add {this.state.title}</button>
                        </div>
                      </div>
                  </div>
                </div>

                <div className="box-content">
                    {/** load data */}
                    <DataTable
                      style={{fontSize:"20px"}}
                      columns={columns}
                      data={this.state.filterDataList}
                      pagination
                      highlightOnHover
                    />
                </div>

                <div id="AddTeamPlantSlocWindow" className="add-new-window" style={{
                          position: 'absolute', top: '20%',
                          left: '50%',
                          marginLeft: '-260px',
                          display: this.state.AddTeamPlantSlocDisplay
                      }}>
                  <form className="needs-validation" onSubmit={(e)=>this.ClickAction(e)}>
                  <div>
                    <div className="header-add-problem-type-window">{this.state.actionTeamPlantSLOC} {this.state.title}</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Operator</div>
                        <div>
                            <select
                            id="OperatorAdd"
                            placeholder="Please select Operator"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={this.setOperatorAdd}
                            value={this.state.operatorIDAdd}
                            disabled={(this.state.disableChangeValue)? "disabled":false}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                            {this.state.operatorAdd.map((item, index) => (
                              <option
                                value={item.operator_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.operator_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>Project</div>
                        <div>
                            <select
                                  id="ProjectAdd"
                                  placeholder="Please select Project"
                                  className="dropdrowtype input-text-add-problem-type form-select"
                                  onChange={(e)=>this.setProjectDataAdd(e)}
                                  value={this.state.projectIDAdd}
                                  disabled={(this.state.disableChangeValue)? "disabled":false}
                                  required
                                >
                                <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                                {this.state.projectDataAdd.map((item, index) => (
                                  <option value={item.project_id} key={`layout_b_${index}`}>
                                    {item.project_name}
                                  </option>
                                ))}
                              </select>
                        </div>
                      </div>

                    </div>

                    {/* row2 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{/*(this.state.factUpdate)? this.state.LangTranslate[locale]["teamName"] : */`Team Group`}</div>
                        <div>
                            <select
                            id="TeamAdd"
                            placeholder="Please select Team Group"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setTeamGroupAdd(e)}
                            value={this.state.teamGroupIDAdd}
                            disabled={(this.state.disableChangeValue)? "disabled":false}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT TEAM GROUP</option>
                            {
                            this.state.TeamGroupDataList.map((item, index) => (
                              <option value={item.team_group_id} key={`layout_b_${index}`}>
                              {item.team_group_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>

                      <div className="col-sm-6 m-0 p-0 pl-3">
                          <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["teamName"] : `Team Name`}</div>
                          <div>
                              <select
                              id="TeamAdd"
                              placeholder="Please select Team Name"
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={(e)=>this.setTeamAdd(e)}
                              value={this.state.teamIDAdd}
                              disabled={(this.state.disableChangeValue)? "disabled":false}
                              required
                            >
                              <option value="" className="please-select">PLEASE SELECT TEAM</option>
                              {
                              this.state.TeamSubDataList.map((item, index) => (
                                <option value={item.team_id} key={`layout_b_${index}`}>
                                {item.team_name}
                                </option>
                              ))}
                              </select>
                          </div>
                      </div>
                    </div>

                    {/* row3 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["plantName"] : `Plant Name`}</div>
                        <div>
                          <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            placeholder="Select plant"
                            value={this.state.plantIDAdd}
                            onChange={(e)=>this.setPlantAdd(e)}
                            required
                          ><option>PLEASE SELECT Plant</option>
                            {this.state.plantList.map(function(item, index) { 
                              return (
                                <option value={item.plant_id} key={index}>
                                  {item.plant_name}
                                </option>
                              )}
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["SLOCName"] : `SLOC Name`}</div>
                        <div>
                        <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            placeholder="Select SLOC"
                            value={this.state.SLOCIDAdd}
                            onChange={(e)=>this.setSLOCNameAdd(e)}
                            required
                          ><option>PLEASE SELECT SLOC</option>
                            {this.state.SLOCList.map(function(item, index) {
                              return (
                                <option value={item.sloc_id} key={index}>
                                  {item.sloc_name+" "+item.sloc_description}
                                </option>
                              )}
                              )}
                          </select>

                        </div>
                      </div>
                    </div>
                    {/* row4 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group
                        id="statusAdd"
                        name="statusAdd"
                        value={this.state.statusAdd}
                        onChange={this.setStatus}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDate} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):""} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDate}  value={(this.state.ExpiryDateAdd != '')? moment(this.state.ExpiryDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isSameOrBefore(moment(this.state.EffectiveDateAdd).add(-1,"day"))}/></div>
                      </div>
                    </div>
                    {/* row6 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={this.onCloseAddNewWindow}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit"  className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;{this.state.actionTeamPlantSLOCButton}&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                  </div>
                </form>
                </div>

                <div id="ConfirmWindow" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplay
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      {
                        (this.state.actionTeamPlantSLOC === "Add")?
                          ((this.state.resultAddNewFail === true)? (<Button type="primary" onClick={()=>this.onCallConfirmWindowAndCallAddNewAgain()}>&nbsp;&nbsp;{(this.state.factUpdate)? this.state.LangTranslate[locale]["butClose"] : `Close`}&nbsp;&nbsp;</Button>) : (<Button style={{cursor:"pointer"}} onClick={()=>this.onResetFormAddNew()}>&nbsp;&nbsp;&nbsp;เพิ่มอีกครั้ง&nbsp;&nbsp;&nbsp;</Button>)):null
                      }&nbsp;&nbsp;
                      {
                        (this.state.resultAddNewFail === false)? <Button type="primary" onClick={()=>this.onCallConfirmWindow()}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>:null
                      }
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(TeamPlantSLOC);

